import { autoserialize, autoserializeAs } from 'cerialize';
import { DateUtil, isNullOrUndefined } from '@uzurv/rideWss/app/util';

export class RideLimitDetail {
  @autoserialize
  organizationRiderId: number;

  @autoserialize
  riderRideLimit: number;

  @autoserialize
  riderRidesRemaining: number;

  @autoserialize
  riderRideLimitPeriod: string;

  @autoserializeAs(Date)
  riderRideLimitPeriodStartDate: Date;

  @autoserializeAs(Date)
  riderRideLimitPeriodEndDate: Date;

  @autoserialize
  organizationAmbulatoryRideLimit: number;

  @autoserialize
  organizationAmbulatoryRidesRemaining: number;

  @autoserialize
  organizationWavRideLimit: number;

  @autoserialize
  organizationWavRidesRemaining: number;

  @autoserialize
  organizationRideLimitPeriod: string;

  @autoserializeAs(Date)
  organizationRideLimitPeriodStartDate: Date;

  @autoserializeAs(Date)
  organizationRideLimitPeriodEndDate: Date;

  static OnSerialized(instance: RideLimitDetail, json: any): void {
    if (!isNullOrUndefined(instance.riderRideLimitPeriodStartDate)) {
      json.riderRideLimitPeriodStartDate = DateUtil.serializeLocalDate(instance.riderRideLimitPeriodStartDate);
    }

    if (!isNullOrUndefined(instance.riderRideLimitPeriodEndDate)) {
      json.riderRideLimitPeriodEndDate = DateUtil.serializeLocalDate(instance.riderRideLimitPeriodEndDate);
    }

    if (!isNullOrUndefined(instance.organizationRideLimitPeriodStartDate)) {
      json.organizationRideLimitPeriodStartDate = DateUtil.serializeLocalDate(instance.organizationRideLimitPeriodStartDate);
    }

    if (!isNullOrUndefined(instance.organizationRideLimitPeriodEndDate)) {
      json.organizationRideLimitPeriodEndDate = DateUtil.serializeLocalDate(instance.organizationRideLimitPeriodEndDate);
    }
  }

  static OnDeserialized(instance: RideLimitDetail, json: any): void {
    if (!isNullOrUndefined(json['riderRideLimitPeriodStartDate'])) {
      instance.riderRideLimitPeriodStartDate = DateUtil.deserializeLocalDate(json['riderRideLimitPeriodStartDate']);
    }

    if (!isNullOrUndefined(json['riderRideLimitPeriodEndDate'])) {
      instance.riderRideLimitPeriodEndDate = DateUtil.deserializeLocalDate(json['riderRideLimitPeriodEndDate']);
    }

    if (!isNullOrUndefined(json['organizationRideLimitPeriodStartDate'])) {
      instance.organizationRideLimitPeriodStartDate = DateUtil.deserializeLocalDate(json['organizationRideLimitPeriodStartDate']);
    }

    if (!isNullOrUndefined(json['organizationRideLimitPeriodEndDate'])) {
      instance.organizationRideLimitPeriodEndDate = DateUtil.deserializeLocalDate(json['organizationRideLimitPeriodEndDate']);
    }
  }
}
